import { association, Factory } from 'miragejs';
import { addDays, format } from 'date-fns';

export default Factory.extend({
  startTime() {
    const tomorrow = addDays(new Date(), 1);
    return format(tomorrow, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
  },
  desk: association(),
  employee: association(),
});
